/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { Form, Formik, yupToFormErrors } from 'formik';
import SectionsInfo from './formsections/coursesections/SectionsInfo';
import AutoSave from '../../../common/form/formik/AutoSave';
import GenericInfo from './formsections/GenericInfo';
import StudentCountInfo from './formsections/StudentCountInfo';
import GradeInfo from './formsections/GradeInfo';
import ValidationHack from './ValidationHack';
import { FormCourseDataOnly } from './CourseDataInfoBox';
import { CourseData } from '@data/course/courseData';
import { courseDataValidationSchema } from '@data/course/courseDataValidationSchema';

interface CourseDataEditorProps {
  initialData: FormCourseDataOnly;
  onChange: (values: FormCourseDataOnly, isValid: boolean) => void;
}

const CourseDataEditor: React.FC<CourseDataEditorProps> = ({ initialData, onChange }) => {
  return (
    <Formik
      initialValues={initialData}
      onSubmit={() => undefined}
      validationSchema={courseDataValidationSchema}
    >
      {(props) => (
        <Form>
          {/* Formik doesn't seem to like validating onMount so we're just gonna hack it and force it manually */}
          <ValidationHack />
          <AutoSave<CourseData> onSave={onChange} />
          <div className='grid grid-cols-1 md:grid-cols-2 mt-8'>
            <div className='children-spaced'>
              <GenericInfo />
              <StudentCountInfo />
              <GradeInfo />
            </div>
            <div className='children-spaced bg-timberwolf px-4'>
              <SectionsInfo {...props} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CourseDataEditor;
